import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';

export const tourNameFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const name = info.getValue() as string | null | undefined;
  const row = info.row.original as RowWithId;
  const tourId = row.id;
  if (!name) return <EmptyValue />;
  if (!tourId) return name;
  return (
    <CellLink
      to="/app/tours/$tourId"
      params={{ tourId }}
      importance={info.column.columnDef.meta?.importance}
    >
      {name}
    </CellLink>
  );
};
